<script setup lang="ts">
import { formatCurrency } from "@/composables/format";
import { makeUpdateCartRes, useCart } from "@/composables/useCart";
import { BButton } from "@/dokos-ui";

const cart = useCart();

const res = makeUpdateCartRes();
async function removeItem(it: any) {
  if (!confirm(`Retirer cet article (${it.qty} ${it.item_name}) ?`)) return;
  await res.fetch({
    item_code: it.item_code,
    qty: 0,
    event_registration: it.event_registration,
    booking: it.resource_booking, // NOTE: Parameter is called booking
    uom: it.uom,
  });
}
</script>

<template>
  <ul>
    <li class="flex items-center" v-for="it in cart.items">
      <span>
        {{ it.item_name }}
        <span class="opacity-70">
          &times;
          {{ it.qty }}
          {{ it.uom }}
        </span>
      </span>

      <span class="ml-auto text-sm">
        {{ formatCurrency(it.amount, cart.currency) }}
      </span>

      <BButton
        size="xs"
        class="!rounded-full"
        theme="red"
        variant="ghost"
        :disabled="res.loading"
        @click="removeItem(it)"
        leading-icon="x#thick"
      />
    </li>
  </ul>

  <table class="w-full my-4 BCartTotalsTable">
    <tbody>
      <tr class="text-sm">
        <th class="text-left">Total HT</th>
        <td class="text-right">
          {{ formatCurrency(cart.net_total, cart.currency) }}
        </td>
      </tr>
      <tr class="text-sm">
        <th class="text-left">Montant des taxes</th>
        <td class="text-right">
          {{ formatCurrency(cart.total_taxes_and_charges, cart.currency) }}
        </td>
      </tr>
      <tr class="text-lg">
        <th class="text-left">TOTAL TTC</th>
        <td class="text-right pt-1 border-t border-">
          {{ formatCurrency(cart.grand_total, cart.currency) }}
        </td>
      </tr>
    </tbody>
  </table>

  <div class="flex">
    <BButton
      :to="{ name: 'Cart' }"
      class="ml-auto"
      size="lg"
      theme="green"
      leading-icon="shopping-bag"
      trailing-icon="arrow-right"
    >
      Valider la commande
    </BButton>
  </div>

  <div class="w-[400px] max-w-[90vw]" />
</template>

<style>
.BCartTotalsTable td {
  width: 0.1%;
  white-space: nowrap;
}
</style>
